const SearchModalSection = ({children, title, titleClass}) => {
    return (
        <div className="grid gap-[12px]">
            {title && <p className={`text-[12px] poppins-medium custom-text-grey-400 ${titleClass}`}>{title}</p>}
            {children}
        </div> 
    );
}
export default SearchModalSection;